export default {"src":"/uk/_next/static/media/spot-combine-pensions.f09d4673.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};